import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { MetricScope } from '../../interfaces/metrics';

@Component({
  selector: 'bst-member-drill-panel',
  templateUrl: './member-drill-panel.component.html',
  styleUrls: ['./member-drill-panel.component.scss'],
  standalone: false,
})
export class MemberDrillPanelComponent {
  userId!: number;
  name = '';
  anchor = '';
  actorCanSeeBillRate = false;
  constructor(public ref: NbDialogRef<MemberDrillPanelComponent>) {}
  get scope(): MetricScope { return { type: 'user', id: this.userId }; }
  close(): void { this.ref.close(); }
}
